import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { Card } from '../ui/Card';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María',
    role: 'Mamá de 2 (4 y 7 años)',
    quote: 'Antes era una batalla diaria. Ahora mi hija de 4 años pide sus tarjetas en lugar de la tele. No puedo creer lo rápido que cambiaron las cosas.',
    rating: 5,
    borderColor: 'red' as const
  }, {
    name: 'Carmen',
    role: 'Emprendedora desde casa',
    quote: 'Lo mejor: no necesito energía extra. El sistema funciona solo. Puedo terminar mis llamadas de trabajo mientras ellos juegan tranquilos.',
    rating: 5,
    borderColor: 'yellow' as const
  }, {
    name: 'Laura',
    role: 'Maestra y mamá',
    quote: 'Recuperé las tardes. Ya no hay gritos ni culpa. Como educadora, me sorprende lo bien diseñadas que están las actividades para captar la atención.',
    rating: 5,
    borderColor: 'green' as const
  }];
  return <section className="py-20 bg-brand-cream" data-id="element-653">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-654">
        <div className="text-center mb-16" data-id="element-655">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4 font-serif" data-id="element-656">
            Historias de Transformación
          </h2>
          <p className="text-slate-700" data-id="element-657">
            Mamás reales que cambiaron el caos por calma
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-658">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-659">
              <Card className="h-full relative" borderColor={t.borderColor} data-id="element-660">
                <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-yellow/30" data-id="element-661" />
                <div className="flex gap-1 mb-4" data-id="element-662">
                  {[...Array(t.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-yellow text-brand-yellow" data-id="element-663" />)}
                </div>
                <p className="text-slate-700 mb-6 italic leading-relaxed" data-id="element-664">
                  "{t.quote}"
                </p>
                <div className="mt-auto pt-4 border-t border-brand-wood/20" data-id="element-665">
                  <p className="font-bold text-brand-navy" data-id="element-666">{t.name}</p>
                  <p className="text-sm text-slate-600" data-id="element-667">{t.role}</p>
                </div>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}